// extracted by mini-css-extract-plugin
export default {"visuallyhidden":"triangle__visuallyhidden--RUGoh","focusable":"triangle__focusable--TKL7g","triangle":"triangle__triangle--hPLgA"};